// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';

type Props = {
  step: {[key: string]: string},
  number: number,
};

const useStyles = makeStyles(theme => ({
  containerStep: {
    width: '100%',
    display: 'flex',
    margin: theme.spacing(2, 0, 2, 0),
  },
  circleNumber: {
    width: '2rem',
    height: '1.75rem',
    marginRight: theme.spacing(1),
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFFFFF',
    border: '1px solid #E5D7FF',
    '& p': {
      color: '#7B39FF',
      margin: '0',
      fontSize: '16px',
      fontWeight: 600,
    },
    [theme.breakpoints.up('md')]: {
      width: '2.25rem',
      height: '2rem',
    },
  },
  descriptionStep: {
    width: '100%',
  },
  stepName: {
    color: ' #3A3A49',
    fontWeight: '600',
    fontSize: '14px',
  },
  stepDescription: {
    color: '#55556D',
    letterSpacing: '0.005em',
    fontSize: '12px',
  },
}));

export default function ReferralStep(props: Props) {
  const {step, number} = props;
  const classes = useStyles();
  return (
    <div className={classes.containerStep}>
      <div className={classes.circleNumber}>
        <p>{number}</p>
      </div>
      <div className={classes.descriptionStep}>
        <Typography className={classes.stepName}>{step.name}</Typography>
        <Typography className={classes.stepDescription}>
          {step.description}
        </Typography>
      </div>
    </div>
  );
}

ReferralStep.propTypes = {
  step: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
};
